import { Row } from "antd";
import Text from "antd/es/typography/Text";

export default function LoadingMessage() {
    return (
        <Row
            key="0"
            style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 8,
            }}
        >
            <Text>Carregando...</Text>
        </Row>
    )
}